import { GameSetupConfig } from '../configs/game-setup.config'
import {
  CommandResponse,
  QueryErrorCode,
  QueryResponse,
  SpecificationResult,
} from 'shared-services'
import { CreateGameSetupErrorCode } from '../error-codes/create-game-setup.error-code'
import { CreateGameSetupRequest } from '../requests/create-game-setup.request'
import { FilteredPlayer } from '../models/filtered-player'
import { CanCreateGameSetupErrorCode } from '../error-codes/can-create-game-setup.error-code'

export class CreateGameSetupService {
  public constructor(private readonly gameSetupConfig: GameSetupConfig) {}

  public async getPoolPointsOptions(): Promise<
    QueryResponse<number[], QueryErrorCode>
  > {
    const response = await fetch(
      `${this.gameSetupConfig.apiBaseUrl}/v1/pool-points-options`,
      {
        credentials: 'include',
      },
    )

    return (await response.json()) as QueryResponse<number[], QueryErrorCode>
  }

  public async getDoublingCountRoundOptions(): Promise<
    QueryResponse<number[], QueryErrorCode>
  > {
    const response = await fetch(
      `${this.gameSetupConfig.apiBaseUrl}/v1/doubling-count-round-options`,
      {
        credentials: 'include',
      },
    )

    return (await response.json()) as QueryResponse<number[], QueryErrorCode>
  }

  public async canCreateGame(): Promise<
    QueryResponse<
      SpecificationResult<CanCreateGameSetupErrorCode>,
      QueryErrorCode
    >
  > {
    const response = await fetch(
      `${this.gameSetupConfig.apiBaseUrl}/v1/can-create-game`,
      {
        credentials: 'include',
      },
    )

    return (await response.json()) as QueryResponse<
      SpecificationResult<CanCreateGameSetupErrorCode>,
      QueryErrorCode
    >
  }

  public async createGame(
    createGameSetupRequest: CreateGameSetupRequest,
  ): Promise<CommandResponse<CreateGameSetupErrorCode>> {
    const response = await fetch(
      `${this.gameSetupConfig.apiBaseUrl}/v1/create-game`,
      {
        method: 'POST',
        body: JSON.stringify(createGameSetupRequest),
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      },
    )

    return (await response.json()) as CommandResponse<CreateGameSetupErrorCode>
  }

  public async filterPlayers(
    usernameFilter: string,
  ): Promise<QueryResponse<FilteredPlayer[], QueryErrorCode>> {
    const query = `usernameFilter=${usernameFilter}`

    const response = await fetch(
      `${this.gameSetupConfig.apiBaseUrl}/v1/filter-players?${query}`,
      {
        credentials: 'include',
      },
    )

    return (await response.json()) as QueryResponse<
      FilteredPlayer[],
      QueryErrorCode
    >
  }
}
